module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/shibuya_sns_04-9f1a848f56e3ce311740c22a9a99ce64.jpg";